/* eslint-disable no-nested-ternary */
import React from 'react'

import translationMappings from '../../../transifex/translationMappings'

const LockEventTabs = ({ t, groupedEvents, activeEventTypeTab, setActiveEventTypeTab }) => {
  const eventTypes = [...groupedEvents.keys()]
  const sortedEventTypes = Object.keys(translationMappings).filter((eventType) => eventTypes.includes(eventType))

  return (
    <div className="flex">
      {sortedEventTypes.map((eventType, i) => {
        const isTabActive = activeEventTypeTab === eventType
        const isFirst = i === 0
        const isLast = i === eventTypes.length - 1

        return (
          <div
            key={eventType}
            style={{
              background: isTabActive ? '#006e78' : '#FFF',
              color: isTabActive ? '#FFF' : '#000',
              padding: 6,
              cursor: 'pointer',
              border: '1px solid #d3d3d3',
              borderRadius: isFirst ? '10px 0 0 10px' : isLast ? '0 10px 10px 0' : '0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={() => setActiveEventTypeTab(isTabActive ? '' : eventType)}
          >
            {t(translationMappings[eventType] || eventType)} ({groupedEvents.get(eventType).length})
          </div>
        )
      })}
    </div>
  )
}

export default LockEventTabs
